import termsSource from '../../content/legal/terms.md?raw';
import { LegalLayout } from './LegalLayout';

export default function Terms() {
  return <LegalLayout source={termsSource} />;
}
